import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const VerificationModule = lazy(loadModule);

export default VerificationModule;
